import * as _ from 'lodash';
import portalCommunication from '@3plearning/mathletics-portal-communication-service';
import { NUMBER_OF_LOADING_ITEMS } from '../../config';
import { getAuthToken } from '../../helpers/auth';
import { getLocale } from '../../helpers/locale';

export const LIBRARY_ITEMS_LOADED = 'LIBRARY_ITEMS_LOADED';
export const LIBRARY_ITEM_LOADED = 'LIBRARY_ITEM_LOADED';
export const LIBRARY_ITEM_SELECTED = 'LIBRARY_ITEM_SELECTED';
export const LIBRARY_ITEM_LOAD_FAILED = 'LIBRARY_ITEM_LOAD_FAILED';
export const RELOAD_FILTERED_ITEMS = 'RELOAD_FILTERED_ITEMS';
export const LOAD_MORE_LIBRARY_ITEMS = 'LOAD_MORE_LIBRARY_ITEMS';

export function libraryItemsLoaded(items) {
    portalCommunication.requestLoadingSpinner(false);
    return {
        type: LIBRARY_ITEMS_LOADED,
        allItems: items
    };
}

export function libraryItemLoaded(detail) {
    portalCommunication.requestLoadingSpinner(false);
    const selectedItem = _.first(_.filter(detail.items, item => item.type === detail.selectedType));
    return {
        type: LIBRARY_ITEM_LOADED,
        items: detail.items,
        selectedItem
    };
}

export function libraryItemLoadFailed() {
    portalCommunication.requestServerError();
}

export function loadMoreRenderedItems(loadNumber = NUMBER_OF_LOADING_ITEMS) {
    return { type: 'LOAD_MORE_LIBRARY_ITEMS', loadNumber };
}

export function loadLibraryItems() {
    portalCommunication.requestLoadingSpinner(true);
    return { type: 'FETCHING_LIBRARY_ITEMS' };
}

export function reloadFilteredItems() {
    return (dispatch) => {
        dispatch({ type: RELOAD_FILTERED_ITEMS });
    };
}

export function switchLibraryItemType(selectedItemType) {
    return (dispatch, getState) => {
        const currentlySelectedItem = getState().libraryReducer.selectedItemDetail;
        currentlySelectedItem.selectedType = selectedItemType;
        dispatch(libraryItemLoaded(currentlySelectedItem));
    };
}

export function libraryItemSelected(itemUrl, selectedType) {
    portalCommunication.requestLoadingSpinner(true);
    return (dispatch) => {
        getAuthToken()
            .then(authToken => fetch(itemUrl, {
                headers: {
                    AuthToken: authToken,
                    Locale: getLocale() || 'en'
                }
            }))
            .then(response => response.json())
            .then(response => dispatch(libraryItemLoaded({
                items: response,
                selectedType
            })))
            .catch(() => dispatch(libraryItemLoadFailed));
    };
}
